import { clearLoginInfo } from '../stores';
import { formSubmit } from './form-submit';

export const pageRedirects = {
  forgotPasswordPage: () => (window.location.href = `${location.origin}/sign-in/forgot-password${location.search}`),
  proxyPage: () => (window.location.href = `${location.origin}/ciam-proxy${location.search}`),
  approvalStatusError: (status: string) => {
    clearLoginInfo();
    location.assign(`/approval-status-error?approvalStatus=${status}`);
  },
  newChannelAd: ({ uid, channel }: { uid: string; channel: string }) => {
    clearLoginInfo();
    formSubmit(`/new-channel/register/${channel}`, { adCdcUid: uid });
  },
  channelExpand: ({ uid, channel }: { uid: string; channel: string }) => {
    clearLoginInfo();
    formSubmit(`/new-channel/ssoAccess`, { cdc_uid: uid, targetChannel: channel });
  },
  consentUpdate: ({
    uid,
    uidSignature,
    signatureTimestamp,
    spName,
    samlContext,
    channel,
  }: {
    uid: string;
    uidSignature: string;
    signatureTimestamp: string;
    spName: string;
    samlContext: string;
    channel: string;
  }) => {
    clearLoginInfo();
    formSubmit(`/consent-update/${channel}`, {
      uid: uid,
      siteUID: uid,
      UIDSig: uidSignature,
      signatureTimestamp,
      spName,
      samlContext,
    });
  },
};
